export const PURCHASE_ORDER_VALIDATION_SCHEMA = {
  vendor: {
    required: 'Vendor is required',
  },
  currency: {
    required: 'Currency is required',
  },
  expiration_date: {
    required: 'Expiry date is required',
  },
  shipping_charge_hsn_code: {
    required: 'Shipping charge HSN code is required',
  },
};
